import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';

const DuplicateSongToast = ({ message, songId }) => (
    <div>
        {message} <Link to={`/songs/${songId}`} className="toast-link">Перейти к песне</Link>
    </div>
);

const CreateSongModal = ({ show, onClose, onSongCreated }) => {
    const [title, setTitle] = useState('');
    const [isCreating, setIsCreating] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmedTitle = title.trim();

        if (!trimmedTitle) {
            setError('Название песни не может быть пустым.');
            return;
        }

        setIsCreating(true);
        setError('');

        try {
            const response = await apiClient.post('/songs/', { title: trimmedTitle });
            toast.success('Песня успешно создана!');
            onSongCreated(response.data); // Передаем созданную песню обратно
            handleClose();
        } catch (err) {
            if (err.response && err.response.status === 409 && err.response.data.detail.song_id) {
                const { message, song_id } = err.response.data.detail;
                toast.error(<DuplicateSongToast message={message} songId={song_id} />);
                // Не закрываем окно, чтобы пользователь мог исправить название
            } else if (err.response && err.response.status === 409) {
                // Обработка старого формата ошибки или ошибки от upload_from_file
                const errorMessage = typeof err.response.data.detail === 'string' ? err.response.data.detail : 'Песня с таким названием уже существует.';
                setError(errorMessage);
            }
            else {
                setError('Произошла ошибка при создании песни.');
                toast.error('Произошла ошибка при создании песни.');
            }
        } finally {
            setIsCreating(false);
        }
    };

    const handleClose = () => {
        setTitle('');
        setError('');
        setIsCreating(false);
        onClose();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Создать новую песню</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="songTitle">
                        <Form.Label>Название песни</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => {
                                setTitle(e.target.value);
                                if (error) setError('');
                            }}
                            placeholder="Введите название"
                            isInvalid={!!error}
                            autoFocus
                        />
                        <Form.Control.Feedback type="invalid">
                            {error}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isCreating}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={isCreating || !title.trim()}>
                    {isCreating ? 'Создание...' : 'Создать'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateSongModal;
